import { render, staticRenderFns } from "./SignupLanding.vue?vue&type=template&id=5238f3b6&scoped=true&"
import script from "./SignupLanding.vue?vue&type=script&lang=js&"
export * from "./SignupLanding.vue?vue&type=script&lang=js&"
import style0 from "./SignupLanding.vue?vue&type=style&index=0&id=5238f3b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5238f3b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VContent,VFlex,VImg,VLayout,VRow})
